import { createRouter, createWebHistory } from "vue-router";
import Login from "../pages/Login.vue"
import Home from "../pages/Home.vue"
import Users from "@/pages/Users.vue";
import store from './../vuex/store'
import folder from "../components/Folder/Index.vue"
import Starred from "@/pages/Starred.vue";
import ShareWithMe from "@/pages/ShareWithMe.vue";
import Trash from "@/pages/Trash.vue";
import PageNotFound from "../pages/PageNotFound.vue"
const routes = [
    {
        name: "Login",
        component: Login,
        path: "/login",
    },
    {
        name: "Home",
        component: Home,
        path: "/",
    },
    {
        name: "Users",
        component: Users,
        path: "/users",
    },
    {
        name: "Starred",
        component: Starred,
        path: "/starred",
    },
    {
        name: "ShareWithMe",
        component: ShareWithMe,
        path: "/shared-with-me",
    },
    {
        name: "Trash",
        component: Trash,
        path: "/trash",
    },
    {
        path: '/folder',
        name: 'Folder',
        component: folder,
        props: route => ({
            pathParam: route.query.path,
            fileParam: route.query.file
        })
    },
    {
        path: "/:catchAll(.*)",
        name: "PageNotFound",
        component: PageNotFound
    },
]

// let router = createRouter({
//     history: createWebHistory(),
//     mode: 'history',
//     routes,
// });

let router = createRouter({
    history: createWebHistory(),
    routes,
    linkExactActiveClass: 'active' // 👈 global active class
});
router.beforeEach((to, from, next) => {
    if (to.name == 'PageNotFound'){
        store.state.user.PageNotFound = 1
        next()
    } else if (to.name == 'Login'){
        if (store.state.user.accessToken == '') {
            let token = localStorage.getItem('mDrivetoken');
            if (token) {
                store.state.user.accessToken = token
                next('/')        
            }
            next()
        } else{
            next('/')        
        }
    } else if (to.name != 'Login') {
        if(store.state.user.accessToken == '') {
            let token = localStorage.getItem('mDrivetoken');
            if (token) {
                store.state.user.accessToken = token
                next()        
            }
            next('/login')        
        } else {
            next()        
        }
    } else {
        next()        
    }
})
export default router;
